import {
  Config,
  IFinalResponse,
  InitApiType,
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
  BussinessErrorLocalType,
  REPO_API,
} from '../Core';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/utils/zipCode/check';

export const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
export const URL_POSTMAN = `${REPO_API}/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/2c8ab43b-90ff-4eb7-b0f6-5ef8c2d7daa0?version=e108b88d-e44f-49ee-8b46-4c64ad6068fe&tab=overview`;

export const CODE_ERRORS: ErrorResponseCodeType<BussinessErrorLocalType>[] = [
  {
    code: '01',
    bussinessErrorVariant: 'zipCodeNotFilled',
    message: 'ZipCode not filled',
  },
  {
    code: '02',
    bussinessErrorVariant: 'zipCodeNotExists',
    message: 'ZipCode does not exists',
  },
];

const definitions = {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};

const callGet = async (params: {
  zipcode: string;
}): Promise<IFinalResponse> => {
  const init: InitApiType = {
    params,
  };
  return Config.API.get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { get: callGet };

export default { call, definitions };
